// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomerReview_wrapper__4YoPe","text":"CustomerReview_text__2mwFV","author":"CustomerReview_author__VDFAS","star":"CustomerReview_star__UmD0l"};